module.exports = __webpack_public_path__ + "static/img/13.6a45bfc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/sp/13.png
// module id = +EY3
// module chunks = 0